/**
 * Product Variant Button Handler
 * Handles click events for Fantech-style color variant buttons
 * Syncs with hidden radio inputs for form compatibility
 */
(function () {
  'use strict';

  // Handle variant button clicks
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.fantech-product-card__variant-button--color');
    if (!button) return;

    event.preventDefault();

    // Don't allow clicking unavailable variants
    if (button.getAttribute('data-variant-available') === 'false') {
      return;
    }

    // Remove active state from all sibling buttons
    var container = button.closest('.product-form__input');
    if (container) {
      var siblings = container.querySelectorAll('.fantech-product-card__variant-button--color');
      siblings.forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
    }

    // Set current button as active
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    // Find and check the linked hidden radio input
    var radioId = button.getAttribute('data-linked-input');
    if (radioId) {
      var radio = document.getElementById(radioId);
      if (radio) {
        radio.checked = true;

        // Trigger change event for variant-selects web component
        var changeEvent = new Event('change', { bubbles: true });
        radio.dispatchEvent(changeEvent);
      }
    }
  });

  // Initialize active states on page load
  document.addEventListener('DOMContentLoaded', function () {
    var checkedRadios = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
    checkedRadios.forEach(function (radio) {
      var linkedButton = document.querySelector('[data-linked-input="' + radio.id + '"]');
      if (linkedButton && linkedButton.classList.contains('fantech-product-card__variant-button--color')) {
        linkedButton.classList.add('is-active');
        linkedButton.setAttribute('aria-pressed', 'true');
      }
    });
  });
})();
